import { render, staticRenderFns } from "./Cookie.vue?vue&type=template&id=57e9c8de&scoped=true"
var script = {}
import style0 from "./Cookie.vue?vue&type=style&index=0&id=57e9c8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e9c8de",
  null
  
)

export default component.exports